/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptFiltersRequest {
    getFixupPrototypeFunction() { return PromptFiltersRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptFiltersRequest>): PromptFiltersRequest {
        let obj = Object.assign(new PromptFiltersRequest(), model);
        PromptFiltersRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptFiltersRequest>): PromptFiltersRequest {
        if (!model) return null;
        return PromptFiltersRequest.newInstance(<PromptFiltersRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptFiltersRequest) {
        if (!obj) return;

        models.PromptFiltersRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptFiltersRequest): boolean {
        Object.setPrototypeOf(obj, PromptFiltersRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * IDs of the agent
     */
    agent_ids: Array<string>;

    /**
     * Type of the prompt
     */
    prompt_type: models.AgentPromptTypes;

}
